import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    marginTop: 70,
    gap: theme.spacing.space24,
    display: "flex",
    flexDirection: "column",
    padding: `${theme.spacing.space8}px 0`,
  },
  bundlePreview: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space16,
    padding: `0 ${theme.spacing.space24}px`,
    height: 120,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    width: "-webkit-fill-available",
  },
}));
